import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import './Hero.css';

export function Hero({ name, title, location, bio, email, phone }) {
  return (
    <section className="hero">
      <motion.div
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="hero-content"
      >
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6 }}
          whileHover={{ scale: 1.25 }}
          className="hero-avatar"
        >
          <img src="/images/foto2.jpg" alt={name} className="avatar-image" />
        </motion.div>
        <h2 className="hero-name">{name}</h2>
        <p className="hero-title">{title}</p>
        {location && <p className="hero-location">{location}</p>}
        <p className="hero-bio">{bio}</p>
        <div className="hero-buttons">
          <a href="#contact" style={{ textDecoration: 'none' }}>
            <Button variant="default" size="md">
              Contact Me
            </Button>
          </a>
          <a href="#experience" style={{ textDecoration: 'none' }}>
            <Button variant="outline" size="md">
              View Experience
            </Button>
          </a>
        </div>
      </motion.div>
    </section>
  );
}
